import {React, PropTypes} from '../../libs';
import Icon from '../icon';
import I18n from '../i18n';

export default function Launchpad(props) {
  const {config} = props;

  const onClick = React.useCallback(() => {
    document.location = config.uiUrl;
  }, [config]);

  if (!config) {
    return <></>;
  }

  return (
    <div className="application">
      <div className="name" onClick={onClick}>
        <Icon icon="th" iconStyle="fas" />
        <span>
          <I18n t="launchpad.title" />
        </span>
      </div>
    </div>
  );
}

Launchpad.propTypes = {
  /** The configuration for the launchpad. Pass `undefined to hide the launchpad link.*/
  config: PropTypes.object,
};
